/*
 * Advertised price.
 *
 * Liquid renders the correct price and button text on page load
 * (see snippets/advertised-price.liquid and snippets/advertised-button-label.liquid).
 * Theme JS re-renders the product page and quick view from the server on variant change.
 * This file fills the gaps the theme JS leaves:
 * - the sticky cart bar price and label after a variant change,
 * - the "See price in cart" / "Add to Cart" label after a cart change, without a page reload.
 */
(function () {
  const CART_BAR_BLOCKS = '[id^="CartBar-Price-"], [id^="CartBar-AddToCartText-"]';
  const ADVERTISED_LABEL = '[data-advertised-label]';

  // The sticky cart bar rewrites its price and label from the variant on every
  // variant change. Restore the server-rendered blocks from the section HTML
  // the event carries. This runs after cart-bar.js because custom.js loads
  // later in the document and subscribers run in registration order.
  function restoreCartBar({ data }) {
    data?.html?.querySelectorAll(CART_BAR_BLOCKS).forEach((source) => {
      const target = document.getElementById(source.id);
      if (target) target.innerHTML = source.innerHTML;
    });
  }

  // Liquid renders both labels on the span. Pick one by cart state.
  function refreshLabels() {
    const labels = document.querySelectorAll(ADVERTISED_LABEL);
    if (!labels.length) return;

    fetch(`${theme.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const inCart = new Set(cart.items.map((item) => String(item.variant_id)));
        labels.forEach((label) => {
          const { variantId, labelInCart, labelNotInCart } = label.dataset;
          label.textContent = inCart.has(variantId) ? labelInCart : labelNotInCart;
        });
      })
      .catch((error) => console.warn('Add to cart label refresh failed', error));
  }

  subscribe(theme.PUB_SUB_EVENTS.variantChange, restoreCartBar);
  // The cart drawer dispatches this after every add, quantity change, and remove.
  document.addEventListener('theme:cart:added', refreshLabels);
})();
